// In development these relative paths are proxied by Vite to localhost:5000.
// In deployed environments the frontend should keep API and hub traffic same-origin
// so the container proxy can forward requests without introducing browser CORS.
const API_BASE_URL = "/api";
const REQUEST_READINGS_HUB_URL = "/api/requestreadingshub";
const KIOSK_HUB_URL = "/api/kioskhub";

function buildSwaggerUrl(apiBaseUrl) {
  const configuredSwaggerUrl = import.meta.env.VITE_SWAGGER_URL;
  if (configuredSwaggerUrl) {
    return configuredSwaggerUrl;
  }

  if (/^https?:\/\//i.test(apiBaseUrl)) {
    const url = new URL(apiBaseUrl);
    const path = url.pathname.replace(/\/+$/, "");
    url.pathname = path.endsWith("/api")
      ? `${path.slice(0, -4)}/swagger/index.html`
      : `${path}/swagger/index.html`;
    url.search = "";
    url.hash = "";
    return url.toString();
  }

  if (typeof window !== "undefined") {
    const origin = window.location.origin;
    if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(origin)) {
      return `${origin.replace(/:\d+$/, ":5000")}/swagger/index.html`;
    }
  }

  return "/swagger/index.html";
}

function apiUrl(path) {
  if (!path) return API_BASE_URL;
  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

const SWAGGER_URL = buildSwaggerUrl(API_BASE_URL);

export {
  API_BASE_URL,
  REQUEST_READINGS_HUB_URL,
  KIOSK_HUB_URL,
  SWAGGER_URL,
  apiUrl,
};
